import { isRussianClient } from 'utils/common'

import { isAppSumoUser } from 'common/utils/permissions'

const ONE_TIME_PRODUCT_NAMES = {
    SMALL: 'Small',
    MEDIUM: 'Medium',
    LARGE: 'Large',
}

export const getFormattedPrice = (price, currency) => `${currency} ${price.toFixed(2)}`

export const getFormattedProductName = productName => {
    const isOneTimeProduct = Object.values(ONE_TIME_PRODUCT_NAMES).includes(productName)

    if (isAppSumoUser() && !isOneTimeProduct) return productName

    const splittedProductName = productName.split(' ')[0]

    if (isOneTimeProduct && isRussianClient()) {
        if (splittedProductName === ONE_TIME_PRODUCT_NAMES.SMALL) return 'Мини'
        if (splittedProductName === ONE_TIME_PRODUCT_NAMES.MEDIUM) return 'Стандарт'
        if (splittedProductName === ONE_TIME_PRODUCT_NAMES.LARGE) return 'Всё включено'
    }

    return splittedProductName
}
